import type { ColumnView } from '@retro/shared';
import { columnAccent } from '../../lib/colors.js';

/**
 * Column layout shared by the board phases.
 *
 * The track owns the scrolling: on phones the columns stack vertically and the
 * whole track scrolls the familiar way — no horizontal swipe, no nested scroll
 * container. On wider screens the columns sit side by side and the track
 * scrolls horizontally when there are too many to fit.
 */
export function BoardTrack({ children }: { children: React.ReactNode }) {
  return (
    <div
      data-testid="board-track"
      className="board thin-scroll flex-1 overflow-x-hidden sm:overflow-x-auto"
    >
      {children}
    </div>
  );
}

export function BoardColumn({
  column,
  index = 0,
  badge,
  action,
  children,
}: {
  column: ColumnView;
  index?: number;
  badge?: React.ReactNode;
  action?: React.ReactNode;
  children: React.ReactNode;
}) {
  return (
    <section className="col" aria-label={column.title}>
      <header className="col-h" style={{ borderTopColor: columnAccent(index) }}>
        <h3>
          {column.title}
          {badge}
        </h3>
        {column.description ? <p>{column.description}</p> : null}
      </header>
      <div className="col-b">
        {action}
        {children}
      </div>
    </section>
  );
}
